export function transformUrl(url?: string): string {
  if (!url) return '';
  const backendUrl = 'https://backend.microkhim.com.ua';
  const frontendUrl = 'https://www.microkhim.com.ua';
  return url.replace(backendUrl, frontendUrl);
}
